/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 角色部門員工職稱對應檔
 */
export interface RoleDepartmentUserType { 
    /**
     * 使用者職務角色對應資料ID
     */
    departmentId?: number;
    /**
     * 角色資料ID
     */
    roleId?: number;
    /**
     * 部門人員屬性 Ref. SystemDropDownList.Code Where Type='DepartmentUserType'
     */
    departmentUserType?: string;
    updateUserNo?: string;
    updateTime?: Date;
}